<div *ngIf="feeder && feeder.condition">
  <div *ngIf="validateView(feeder, type)">
    <div
      style="text-align: center; padding: 22px; font-weight: 700"
      *ngIf="validateView(feeder, type) === 'server' || validateView(feeder, type) === 'loading'"
    >
      {{ "general.loading" | translate }} {{ validateText(type) }}
    </div>
    <div class="center">
      <div
        class="w-100"
        *ngIf="
          validateView(feeder, type) === 'server' ||
          validateView(feeder, type) === 'done' ||
          validateView(feeder, type) === 'loading' ||
          validateView(feeder, type) === 'socketError'
        "
      >
        <div class="border border-success center p-1 mr-1 mb-3">
          <i class="fa fa-check-circle text-success mr-1" aria-hidden="true"></i>
          <small>{{ "testing.server-response" | translate }}</small>
        </div>
      </div>
      <div class="w-100">
        <div
          *ngIf="validateView(feeder, type) === 'done'"
          class="border border-success center p-1 mb-3"
        >
          <i class="fa fa-check-circle text-success mr-1" aria-hidden="true"></i>
          <small>{{ "testing.feeders-response" | translate }}</small>
        </div>
        <div
          *ngIf="validateView(feeder, type) === 'socketError'"
          class="border border-danger center p-1 mb-3"
        >
          <i class="fa fa-times text-danger mr-1" aria-hidden="true"></i>
          <small>{{ "testing.feeders-response" | translate }}</small>
        </div>
        <div
          class="border border-warning center p-1 mb-3"
          *ngIf="
            validateView(feeder, type) === 'server' || validateView(feeder, type) === 'loading'
          "
        >
          <div class="spinner-border text-warning" role="status" style="height: 13px; width: 13px">
            <span class="sr-only"></span>
          </div>
          <small>{{ ("testing.feeders-response" | translate) + " " + type }}</small>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="feeder && !feeder.condition">
  <div class="text-petition">
    <div class="w-100">
      <div class="border border-success center p-1 mb-md-33">
        <i class="fa fa-check-circle text-success mr-1" aria-hidden="true"></i>
        <small>{{ "testing.server-response" | translate }}</small>
      </div>
    </div>
    <div class="w-100">
      <div class="border border-danger center p-1 mb-md-3">
        <i class="fa fa-times text-danger mr-1" aria-hidden="true"></i>
        <small>{{ "testing.feeders-response" | translate }}</small>
      </div>
    </div>
  </div>
</div>
